import { CRBTUICSSStyle, CRBTUICSSStyleImpl } from '../crbt/crbtuicss';

export interface TransactionHistoryCSSStyle extends CRBTUICSSStyle
{
   
}

export class TransactionHistoryCSSStyleImpl extends CRBTUICSSStyleImpl implements TransactionHistoryCSSStyle
{
   getWrapperCSSStyle(): object
   {
        return {
            height: "100%",
            width: "100%",
            paddingLeft: "5%",
            paddingRight: "5%",
        };
   }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/transactionhistory/transactionhistorylistcss.tsx